@if (documentId()) {
  <soft-document-preview
    class="soft-document-preview-panel__body"
    [base64]="base64()"
    [loading]="isLoading()"
    [fileName]="fileName()"
    (reload)="reload()"
  />
} @else {
  <div
    class="soft-document-preview-panel__empty"
    data-testid="document-preview-panel-no-document"
  >
    <soft-ds-icon name="fa-regular fa-file-lines" size="xl" />
    <p>{{ '#WWS_DOCUMENTS.PREVIEW.NO_DOCUMENT' | translate }}</p>
  </div>
}
